export const EMPTY_PAYMENT_PLAN = {
  attributes: {
    installment_number: '',
    days_to_receive: '',
    percent_fee: '',
    description: '',
  },
}
